import {
    ButtonFlavor,
    ButtonType,
    DialogHeaderContent,
    ExButton,
    ExDialog,
    ExTextarea,
} from '@boomi/exosphere';
import { useState } from 'react';

import './approve-reject-dialog.css';

interface ApproveRejectDialogProps {
    isOpen: boolean;
    mode: 'approve' | 'reject';
    onCancel: (comments: string | null) => void;
    onConfirm: (comments: string | null) => void;
}

export const ApproveRejectDialog = ({
    isOpen,
    mode,
    onCancel,
    onConfirm,
}: ApproveRejectDialogProps) => {
    const [comments, setComments] = useState<string | null>(null);

    const handleConfirm = () => {
        onConfirm(comments);
        setComments(null);
    };

    const handleCancel = () => {
        onCancel(comments);
        setComments(null);
    };

    return (
        <ExDialog
            className="approve-reject-dialog"
            dialogTitle={mode === 'reject' ? 'Reject Task' : 'Approve Task'}
            open={isOpen}
            animated={true}
            headerContent={
                mode === 'reject' ? DialogHeaderContent.CRITICAL : DialogHeaderContent.POSITIVE
            }
            onCancel={handleCancel}
            data-testid="approve-reject-dialog"
        >
            Provide additional comments
            <ExTextarea
                className="comments"
                name="comments"
                label="Comments"
                value={comments ?? ''}
                onInput={(e) => {
                    const value = (e.currentTarget as HTMLTextAreaElement).value;
                    setComments(value === '' ? null : value);
                }}
                data-testid="approve-reject-dialog-comment"
            />
            <ExButton
                slot="footer"
                type={ButtonType.SECONDARY}
                flavor={ButtonFlavor.BRANDED}
                onClick={handleCancel}
                data-testid="approve-reject-dialog-cancel"
            >
                Cancel
            </ExButton>
            <ExButton
                slot="footer"
                type={ButtonType.PRIMARY}
                flavor={mode === 'reject' ? ButtonFlavor.RISKY : ButtonFlavor.BRANDED}
                onClick={handleConfirm}
                data-testid="approve-reject-dialog-confirm"
            >
                {mode === 'reject' ? 'Reject' : 'Approve'}
            </ExButton>
        </ExDialog>
    );
};
